import { render, staticRenderFns } from "./ProductElement.vue?vue&type=template&id=702d4d3b&"
import script from "./ProductElement.vue?vue&type=script&lang=js&"
export * from "./ProductElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports